import { observer } from 'mobx-react';
import { emptyFragment } from '@execonline-inc/execonline-ui';
import { Experience } from '../../../Types';

interface Props {
  experience: Experience;
}

function ProgramDetailsItems(_: Props) {
  return emptyFragment();
}

export default observer(ProgramDetailsItems);
